<template>
  <div id="content" :style="styleItem">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <Controls />
  </div>
</template>

<script>
import Controls from "../components/ControlView.vue"
/**
 * コンテンツ部分
 * 
 * @vue-data {Int} [current] 背景の切り替えフラグ
 * @vue-data {Object} [styleItem] 背景のスタイルオブジェクト
 * @vue-data {Object} [styleItemWorld] 背景のスタイルオブジェクト（世界）
 * @vue-data {Object} [styleItemJapan] 背景のスタイルオブジェクト（日本）
 * @vue-computed {String} currentGame 表示中のView
 */
export default {
  name: "ContentsView",

  components: {
    Controls
  },

  data () {
    return {
      current: 0,
      styleItem: null,
      styleItemWorld: {
        backgroundImage: "url(" + require("../assets/world_map_back.jpg") + ")",
        backgroundSize: "cover"
      },
      styleItemJapan: {
        backgroundImage: "url(" + require("../assets/japan_map_back.jpg") + ")",
        backgroundSize: "cover"
      }
    }
  },

  computed: {
    currentGame () {
      return this.$store.getters.currentGame
    }
  },

  mounted () {
    // console.log("ContentsView")
    this.styleItem = this.styleItemWorld
  },

  watch: {
    currentGame () {
      // console.log("current game is ", this.currentGame)
      this.switchBackgroundImage()
    }
  },

  methods: {
    /**
     * 表示中のViewに応じて背景画像を切り替える（Home画面は日本と世界交互に表示）
     */
    switchBackgroundImage () {
      if (this.currentGame === "Home") {
        if (this.current === 0) {
          this.styleItem = this.styleItemWorld
          this.current = 1
        } else {
          this.styleItem = this.styleItemJapan
          this.current = 0
        }
      } else if (this.currentGame.match(/^World*/i)) {
        this.styleItem = this.styleItemWorld
      } else if (this.currentGame.match(/^Japan/i)) {
        this.styleItem = this.styleItemJapan
      }
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#content
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #29292A
  height: 100%
  width: 100%
  position: absolute
  overflow: scroll
  // background-color: #efeff4

#trump_mark
  height: 80px
  img
    width: 300px

#bk_slide
  position: absolute
  top: 0
  z-index: -999

// #carousel
//   width: 1000px
//   margin: 0 auto

</style>
